import { useState } from 'react';
import { toast } from 'sonner';
import { useCommentActions } from '@/features/tasks/model/comments/useCommentActions';
import { useCompleteTask } from '@/features/tasks/model/useTaskActions';
import CommentFormModal from '@/features/tasks/task-comments/CommentFormModal';
import { addCommentAsResult } from '@/entities/task/api/results';

export function CompleteTaskModalWrapper({
  taskId,
  open,
  onClose,
  onSuccess,
}: {
  taskId: string;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) {
  const { completeTask, isLoading: isCompleting } = useCompleteTask();
  const { createComment, isLoading: isCreatingComment } =
    useCommentActions(taskId);
  const [isAddingResult, setIsAddingResult] = useState(false);

  const isLoading = isCompleting || isCreatingComment || isAddingResult;

  const handleSubmit = async (commentData: { message: string }) => {
    try {
      const message = commentData.message.trim()
        ? `Задача завершена. Комментарий: ${commentData.message}`
        : 'Задача завершена';

      const { commentId } = await createComment({ POST_MESSAGE: message });

      await completeTask({ taskId });

      if (commentId) {
        setIsAddingResult(true);
        try {
          await addCommentAsResult(taskId, commentId);
        } finally {
          setIsAddingResult(false);
        }
      }

      toast.success('Задача завершена и результат закреплен');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Ошибка при завершении задачи:', error);
      toast.error('Не удалось завершить задачу');
      throw error;
    }
  };

  return (
    <CommentFormModal
      taskId={taskId}
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      isLoading={isLoading}
      mode="create"
    />
  );
}
